// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__vEkeF","disabled":"FileBtn_disabled__2nm5S","warn":"FileBtn_warn__3EZrn","fade":"FileBtn_fade__3U22r"};